import {
	CasesBundleClientConfig,
	CasesLootboxClientConfig,
	CharacterSkill,
} from '~/shared';
import { QuestMenu } from '../../components/QuestTab';
import { createSlice } from '../wrappers';

interface IMainMenuSlice {
	tabIndex: number;
	maxTabIndex: number;
	faqIndex: number;
	faqSectionIndex: number;
	activeCase: CasesLootboxClientConfig | null;
	activeBundle: CasesBundleClientConfig | null;
	openCaseResult: string | null;
	menuTabsDisabled: boolean;
	questTabActiveMenuItem: QuestMenu;
	reportVisible: boolean;
	activeReportId: string | null;
	isOpeningCase: boolean;
	activeModalSkill: CharacterSkill;
}

const initialState: IMainMenuSlice = {
	tabIndex: 0,
	maxTabIndex: 5,
	faqIndex: -1,
	faqSectionIndex: -1,
	activeCase: null,
	activeBundle: null,
	openCaseResult: null,
	menuTabsDisabled: false,
	questTabActiveMenuItem: QuestMenu.Quests,
	reportVisible: false,
	activeReportId: null,
	isOpeningCase: false,
	activeModalSkill: CharacterSkill.JOB_FARMER,
};

const mainMenuSlice = createSlice({
	name: 'mainMenu',
	initialState,
	reducers: {
		setTabIndexPrev: (state) => {
			const index = state.tabIndex;
			state.tabIndex = index > 0 ? index - 1 : index;
		},
		setTabIndexNext: (state) => {
			const index = state.tabIndex;
			const maxIndex = state.maxTabIndex;
			state.tabIndex = index < maxIndex ? index + 1 : index;
		},
		setTabIndex: (state, action) => {
			state.tabIndex = action.payload;
		},
		setMaxTabIndex: (state, action) => {
			state.maxTabIndex = action.payload;
			if (state.tabIndex > state.maxTabIndex) {
				state.tabIndex = 0;
			}
		},
		setMenuTabsDisabled: (state, action) => {
			state.menuTabsDisabled = action.payload;
		},
		setFaqIndex: (state, action) => {
			state.faqIndex = action.payload;
		},
		setFaqSectionIndex: (state, action) => {
			state.faqSectionIndex = action.payload;
		},
		setActiveCase: (state, action: { payload: CasesLootboxClientConfig }) => {
			state.activeCase = action.payload;
		},
		setActiveBundle: (state, action: { payload: CasesBundleClientConfig }) => {
			state.activeBundle = action.payload;
		},
		setOpenCaseResult: (
			state,
			action: { payload: string | null; type: string },
		) => {
			state.openCaseResult = action.payload;
		},
		setQuestTabActiveMenuItem: (state, action: { payload: QuestMenu }) => {
			state.questTabActiveMenuItem = action.payload;
		},
		setReportVisible: (state, action: { payload: boolean }) => {
			state.reportVisible = action.payload;
		},
		setActiveReportId: (state, action: { payload: string | null }) => {
			state.activeReportId = action.payload;
		},
		setIsOpeningCase: (state, action: { payload: boolean }) => {
			state.isOpeningCase = action.payload;
		},
		setActiveModalSkill: (state, action: { payload: CharacterSkill }) => {
			state.activeModalSkill = action.payload;
		},
	},
});

export const {
	setTabIndexPrev,
	setTabIndexNext,
	setTabIndex,
	setMaxTabIndex,
	setFaqIndex,
	setFaqSectionIndex,
	setActiveCase,
	setActiveBundle,
	setOpenCaseResult,
	setMenuTabsDisabled,
	setQuestTabActiveMenuItem,
	setReportVisible,
	setActiveReportId,
	setIsOpeningCase,
	setActiveModalSkill,
} = mainMenuSlice.actions;

export default mainMenuSlice.reducer;
